import { IIconProps } from "@/models";
import DocxIcon from "./DocxIcon";
import ExcelIcon from "./ExcelIcon";
import FileIcon from "./FileIcon";
import ImageIcon from "./ImageIcon";
import Mp3Icon from "./Mp3Icon";
import Mp4Icon from "./Mp4Icon";
import PdfIcon from "./PdfIcon";
import PowPointIcon from "./PowPointIcon";
import ZipIcon from "./ZipIcon";
import { twMerge } from "tailwind-merge";

const FileByType = ({
  fileType,
  className,
  ...otherProps
}: IIconProps & { fileType: string }) => {
  console.log(fileType);
  const type = fileType?.toLowerCase()?.replace(".", "");
  if (type === "doc" || type === "docx") {
    return (
      <DocxIcon
        {...otherProps}
        className={twMerge("text-[#0C4DB3]", className)}
      />
    );
  } else if (type === "xls" || type === "xlsx") {
    return (
      <ExcelIcon
        {...otherProps}
        className={twMerge("text-[#046931]", className)}
      />
    );
  } else if (type === "ppt" || type === "pptx") {
    return (
      <PowPointIcon
        {...otherProps}
        className={twMerge("text-[#BF3512]", className)}
      />
    );
  } else if (type === "pdf") {
    return (
      <PdfIcon
        {...otherProps}
        className={twMerge("text-[#DC0000]", className)}
      />
    );
  } else if (
    type === "png" ||
    type === "jpeg" ||
    type === "svg" ||
    type === "jpg" ||
    type === "gif"
  ) {
    return (
      <ImageIcon {...otherProps} className={twMerge("text-black", className)} />
    );
  } else if (type === "mp4") {
    return (
      <Mp4Icon
        {...otherProps}
        className={twMerge("text-[#9747FF]", className)}
      />
    );
  } else if (type === "mp3") {
    return (
      <Mp3Icon {...otherProps} className={twMerge("text-primary", className)} />
    );
  } else if (type === "zip") {
    return (
      <ZipIcon
        {...otherProps}
        className={twMerge("text-[#9747FF]", className)}
      />
    );
  } else {
    return <FileIcon {...otherProps} className={twMerge("", className)} />;
  }
};

export default FileByType;
